import { data } from '@remix-run/node'

export async function loader() {
	throw data('Page not found', { status: 404 })
}

export default () => null
